
import Direct from "../../../assets/outline/Direct.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DirectIcon({ className, dataTestid = "DirectIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Direct data-testid={dataTestid} className={classes} {...rest} />
  );
}
